/**
 * useClienti — F-012 Phase 3 (IMPL-P3-003).
 *
 * TanStack Query hook for the admin business-account list. The `filters` object
 * is part of the query key so changing the search term refetches automatically.
 *
 * Pattern: `features/archivio/hooks` (TanStack Query, feature-local QueryClient).
 */
import { useQuery } from '@tanstack/react-query';

import { listClienti, type ClienteListResponse, type ListClientiQuery } from '../lib/admin-client';

export function useClienti(filters: ListClientiQuery = {}) {
  return useQuery<ClienteListResponse>({
    queryKey: ['admin', 'clienti', filters],
    queryFn: () => listClienti(filters),
  });
}
